import { render, staticRenderFns } from "./page401.vue?vue&type=template&id=31dc1f3f&scoped=true&"
var script = {}
import style0 from "./page401.vue?vue&type=style&index=0&id=31dc1f3f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31dc1f3f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!F:/Projects/Hugo/Ilead/FrontEnd/lbcleadership/Client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
installComponents(component, {VBtn})
